import React from "react";
import { useMutation } from "react-query";
import { toTitleCase } from "../../../../Utils/stringUtls";
import { deliquentPolicies } from "../../../CreditInstance/ProgramFeatures/CreditLimits";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import {
  formatReviewDate,
  createFileDownloadMutation,
} from "../reviewSummaryUtils";
import FilesUploadService from "../../../../Services/FilesUploadService";
import FileDownloadDisplay from "../Components/FileDownloadDisplay";
import {
  additionalPayment,
  aplicableProgramFeatures,
  cardAccountStatement,
  cardActivationChannel,
  cardOrderPlacement,
  cardPrintingAndMailingService,
  cardholderNotification,
  cardholderNotificationChannels,
  channel,
  constumerPaymentOptions,
  creditBreue,
  customerSupportChannels,
  customerSupportProvider,
  distributionMinimumPay,
  letterMailGenerationService,
  lockboxServices,
  paymentDistributionOpt,
  pinManagememt,
  pinManagmentOptions,
  statementGeneratedOn,
} from "../../../CreditInstance/ProgramFeatures/FieldsListingLabels";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";

export const creditLimitOptions = [
  {
    label: "Assign limit based on credit decisioning",
    value: 0,
  },
  {
    label: "Assign limit manually from the administrative portal",
    value: 1,
  },
];

const ProgramFeaturesCreditOverview = ({ data }) => {
  // File download mutation
  const fileDownload = useMutation(
    createFileDownloadMutation(FilesUploadService),
  );

  const downloadFile = async (fileName) => {
    try {
      await fileDownload.mutate(fileName);
    } catch (error) {
      console.log(error);
    }
  };
  const {
    pf_applicable_pf = [],
    pf_applicable_pf_other = "",
    pf_card_be_charged = "",
    pf_type_of_credit_line = "",
    pf_type_of_credit_line_company_name = "",
    pf_type_of_credit_line_contact_name = "",
    pf_type_of_credit_line_job_title = "",
    pf_type_of_credit_line_phone_number = "",
    pf_type_of_credit_line_email = "",
    pf_credit_decisioning = "",
    pf_credit_decisioning_fico_vendor = "",
    pf_credit_decisioning_fico_vendor_other = "",
    pf_credit_decisioning_chc = "",
    pf_credit_decisioning_chc_company_name = "",
    pf_credit_decisioning_chc_contact_name = "",
    pf_credit_decisioning_chc_job_title = "",
    pf_credit_decisioning_chc_phone_number = "",
    pf_credit_decisioning_chc_email = "",
    pf_manual_review = "",
    pf_manual_review_company_name = "",
    pf_manual_review_contact_name = "",
    pf_manual_review_job_title = "",
    pf_manual_review_phone_number = "",
    pf_manual_review_email = "",
    pf_credit_limit = [],
    pf_credit_limit_modification = "",
    pf_kyc_process = "",
    pf_enable_kyc_conduct = "",
    pf_enable_kyc_conduct_no_reason = "",
    pf_kyc_conduct = "",
    pf_kyc_conduct_other = "",
    pf_kyc_conduct_other_company = "",
    pf_kyc_conduct_other_contact_name = "",
    pf_kyc_conduct_other_title = "",
    pf_kyc_conduct_other_phone = "",
    pf_kyc_conduct_other_email = "",
    pf_kyc_conduct_other_address = "",
    pf_kyb_process = "",
    pf_kyb_responsibility = "",
    pf_kyb_responsibility_other_company = "",
    pf_kyb_responsibility_other_contact_name = "",
    pf_kyb_responsibility_other_title = "",
    pf_kyb_responsibility_other_phone = "",
    pf_kyb_responsibility_other_email = "",
    pf_kyb_responsibility_other_address = "",
    pf_card_order_placement = [],
    pf_card_order_placement_channel = [],
    pf_card_order_placement_channel_other = "",
    pf_card_activation_channel = [],
    pf_card_activation_channel_other = "",
    pf_pin_management = "",
    pf_pin_manage_default_pin = "",
    pf_pin_manage_default_pin_other = "",
    pf_pin_mailer = "",
    pf_offline_pin_support = "",
    pf_consumer_payment_opt = [],
    pf_consumer_payment_opt_other = "",
    pf_lockbox_services = "",
    pf_lockbox_services_other_company = "",
    pf_lockbox_services_other_contact_name = "",
    pf_lockbox_services_other_title = "",
    pf_lockbox_services_other_phone = "",
    pf_lockbox_services_other_email = "",
    pf_min_payment_threshold = "",
    pf_min_payment_additional_amount = "",
    pf_payment_dist_opt_greater_min = "",
    pf_payment_dist_opt_for_min = "",
    pf_min_pc_pcalc_method = "",
    pf_min_pc_pprcntg_value = "",
    pf_min_pc_scalc_method = "",
    pf_min_pc_sprcntg_value = "",
    pf_payment_due_date_policy = "",
    pf_payment_due_date_policy_no_of_days = "",
    pf_payment_due_date_policy_fixed_date = "",
    pf_payment_statement_cycle_duration = "",
    pf_late_payment_penalty = "",
    pf_late_payment_fee = "",
    pf_grace_period = "",
    pf_grace_period_days = "",
    pf_card_account_statement = [],
    pf_statement_generation = "",
    pf_statment_generation_date = "",
    pf_credit_card_collection_detail = "",
    pf_credit_card_collection_detail_provider = "",
    pf_credit_bureau_report_required = "",
    pf_credit_reporting_bureaus = [],
    pf_credit_reporting_bureaus_other = "",
    pf_card_usage_restriction = "",
    pf_cash_advance_limit = "",
    pf_cardholder_notification = "",
    pf_cardholder_notification_channels = "",
    pf_cardholder_notifications_channels = "",
    pf_customer_support_channels = "",
    pf_customer_support_who_will_provide = "",
    pf_customer_support_provider_other_company = "",
    pf_customer_support_provider_other_contact_name = "",
    pf_customer_support_provider_other_title = "",
    pf_customer_support_provider_other_phone = "",
    pf_customer_support_provider_other_email = "",
    pf_clm_delinquent = [],
    pf_workflow_and_decision_file = "",
    pf_credit_card_statement_printing_mailing_services = "",
    pf_letter_mail_generation_services = "",
    pf_credit_card_collection_detail_provider_other = "",
    pf_credit_card_collection_detail_provider_other_title = "",
    pf_credit_card_collection_detail_provider_other_email = "",
    pf_credit_card_collection_detail_provider_other_phone = "",
    pf_credit_card_collection_detail_provider_other_address = ""
  } = data["1_1"];

  const formatYesNo = (value) => (value?.length ? toTitleCase(value) : "-");

  const formatSelectedLabels = (selectedValues, options, otherValue = "") => {
    const values = Array.isArray(selectedValues)
      ? selectedValues
      : selectedValues?.length
        ? [selectedValues]
        : [];

    if (!values.length) return "-";

    return values
      .map((value) => {
        const option = options.find((source) => source.value === value);
        return option?.label === "Other" ? otherValue : option?.label;
      })
      .filter(Boolean)
      .join(", ");
  };

  const handleCreditLimitOptions = (value) => {
    if (!value?.length) return "-";
    return value
      .map((val) => creditLimitOptions.find((opt) => opt.value === val)?.label)
      .filter(Boolean)
      .join(", ");
  };

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <ReviewSummarySectionHeading title="Program Features" />

      <div i2c-grid="grid" className="review-summary-gap">
        <div i2c-grid="12@md" className="mt-16">
          <ReviewAttribute
            label="Program Features"
            value={
              pf_applicable_pf?.length
                ? aplicableProgramFeatures
                    .filter((source) =>
                      pf_applicable_pf?.includes(source.value),
                    )
                    .map((source) =>
                      source.value === 11
                        ? pf_applicable_pf_other
                        : source.label,
                    )
                    .filter(Boolean)
                    .join(", ")
                : "-"
            }
          />
        </div>
        <div i2c-grid="12@md">
          <ReviewAttribute
            label="Credit Type"
            value={
              pf_card_be_charged?.length ? toTitleCase(pf_card_be_charged) : "-"
            }
          />
        </div>

        <div i2c-grid="12@md">
          <ReviewAttribute
            label="Type of the credit line"
            value={
              pf_type_of_credit_line?.length
                ? toTitleCase(pf_type_of_credit_line)
                : "-"
            }
          />
        </div>

        {pf_type_of_credit_line === "secure" ? (
          <div i2c-grid="12@md">
            <div className="fw-700 review-summary-section-heading mb-8">
              Credit data aggregator
            </div>
            <div i2c-grid="grid gap-sm">
              <div i2c-grid="6@md">
                <ReviewAttribute
                  label="Company Name"
                  value={
                    pf_type_of_credit_line_company_name?.length
                      ? toTitleCase(pf_type_of_credit_line_company_name)
                      : "-"
                  }
                />
              </div>
              <div i2c-grid="6@md">
                <ReviewAttribute
                  label="Contact Name"
                  value={
                    pf_type_of_credit_line_contact_name?.length
                      ? toTitleCase(pf_type_of_credit_line_contact_name)
                      : "-"
                  }
                />
              </div>
              <div i2c-grid="6@md">
                <ReviewAttribute
                  label="Title"
                  value={
                    pf_type_of_credit_line_job_title?.length
                      ? pf_type_of_credit_line_job_title
                      : "-"
                  }
                />
              </div>
              <div i2c-grid="4@md">
                <ReviewAttribute
                  label="Cell Number"
                  value={
                    pf_type_of_credit_line_phone_number?.length
                      ? pf_type_of_credit_line_phone_number
                      : "-"
                  }
                />
              </div>
              <div i2c-grid="4@md">
                <ReviewAttribute
                  label="Email"
                  value={
                    pf_type_of_credit_line_email?.length
                      ? toTitleCase(pf_type_of_credit_line_email)
                      : "-"
                  }
                />
              </div>
            </div>
          </div>
        ) : null}
        <div i2c-grid="6@md">
          <div className="review-summary-section-heading mb-8">
            Credit Decisioning
          </div>
          <ReviewAttribute
            label="Will i2c Inc. provide credit decisioning or adjudication services?"
            value={
              pf_credit_decisioning?.length
                ? toTitleCase(pf_credit_decisioning)
                : "-"
            }
          />
        </div>
        <div i2c-grid="6@md">
          {pf_credit_decisioning === "yes" ? (
            <div>
              <ReviewAttribute
                label="Which vendor do you work with for FICO score?"
                value={
                  pf_credit_decisioning_fico_vendor === "other"
                    ? pf_credit_decisioning_fico_vendor_other
                    : pf_credit_decisioning_fico_vendor?.length
                      ? toTitleCase(pf_credit_decisioning_fico_vendor)
                      : "-"
                }
              />
            </div>
          ) : (
            <div>
              <div i2c-grid="6@md">
                <div className="review-summary-section-heading mb-8">
                  Credit History Check
                </div>

                <div className="review-summary-section-heading">
                  {pf_credit_decisioning_chc === "other" ? (
                    <>
                      <div i2c-grid="grid gap-sm">
                        <ReviewAttribute
                          label="Company Name"
                          value={
                            pf_credit_decisioning_chc_company_name?.length
                              ? toTitleCase(
                                  pf_credit_decisioning_chc_company_name,
                                )
                              : "-"
                          }
                        />
                        <ReviewAttribute
                          label="Contact name"
                          value={
                            pf_credit_decisioning_chc_contact_name?.length
                              ? toTitleCase(
                                  pf_credit_decisioning_chc_contact_name,
                                )
                              : "-"
                          }
                        />
                        <ReviewAttribute
                          label="Title"
                          value={
                            pf_credit_decisioning_chc_job_title?.length
                              ? pf_credit_decisioning_chc_job_title
                              : "-"
                          }
                        />
                        <ReviewAttribute
                          label="Cell Number"
                          value={
                            pf_credit_decisioning_chc_phone_number?.length
                              ? pf_credit_decisioning_chc_phone_number
                              : "-"
                          }
                        />
                        <ReviewAttribute
                          label="Email"
                          value={
                            pf_credit_decisioning_chc_email?.length
                              ? toTitleCase(pf_credit_decisioning_chc_email)
                              : "-"
                          }
                        />
                      </div>
                    </>
                  ) : pf_credit_decisioning_chc?.length ? (
                    toTitleCase(pf_credit_decisioning_chc)
                  ) : (
                    "-"
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <div i2c-grid="12@md">
          <div i2c-grid="12@md" className="review-summary-section-heading">
            {pf_manual_review === "yes" ? (
              <>
                <ReviewAttribute
                  label="Please confirm if you want to enable a manual review in cases where an application has been rejected or marked for review."
                  value={toTitleCase(pf_manual_review)}
                />
                <div i2c-grid="grid gap-sm">
                  <ReviewAttribute
                    label="Company Name"
                    value={
                      pf_manual_review_company_name?.length
                        ? toTitleCase(pf_manual_review_company_name)
                        : "-"
                    }
                  />
                  <ReviewAttribute
                    label="Contact name"
                    value={
                      pf_manual_review_contact_name?.length
                        ? toTitleCase(pf_manual_review_contact_name)
                        : "-"
                    }
                  />
                  <ReviewAttribute
                    label="Title"
                    value={
                      pf_manual_review_job_title?.length
                        ? pf_manual_review_job_title
                        : "-"
                    }
                  />
                  <ReviewAttribute
                    label="Cell Number"
                    value={
                      pf_manual_review_phone_number?.length
                        ? pf_manual_review_phone_number
                        : "-"
                    }
                  />
                  <ReviewAttribute
                    label="Email"
                    value={
                      pf_manual_review_email?.length
                        ? toTitleCase(pf_manual_review_email)
                        : "-"
                    }
                  />
                </div>
              </>
            ) : pf_manual_review?.length ? (
              <ReviewAttribute
                label="Please confirm if you want to enable a manual review in cases where an application has been rejected or marked for review."
                value={toTitleCase(pf_manual_review)}
              />
            ) : (
              <ReviewAttribute
                label="Please confirm if you want to enable a manual review in cases where an application has been rejected or marked for review."
                value="-"
              />
            )}
          </div>
        </div>

        {pf_workflow_and_decision_file && (
          <FileDownloadDisplay
            label="Workflow and Decision Logic Attachment"
            fileName={pf_workflow_and_decision_file}
            onDownload={downloadFile}
          />
        )}

        <div i2c-grid="6@md">
          <div className="review-summary-section-heading mb-8">Credit Limit</div>
          <ReviewAttribute
            label="Please confirm if you want the credit limits to be assigned based on
            your credit decisioning model or will these be defined manually."
            value={handleCreditLimitOptions(pf_credit_limit)}
          />
        </div>

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Credit Limit Modification
          </div>
          <ReviewAttribute
            label="Can the initially assigned credit limit be increased or decreased for the consumers in this card program?"
            value={formatYesNo(pf_credit_limit_modification)}
          />
          {pf_credit_limit_modification === "yes" ? (
            <div i2c-grid="12@md">
              {/* pf_clm_delinquent */}

              <div className="review-summary-section-heading mt-16 mb-16">
                Charge-Off Process and Delinquent Accounts Policy
              </div>
              <div className="overview-val-text">
                <table border={1} cellSpacing={0}>
                  <thead>
                    <tr>
                      <th width="400">Delinquency Action</th>
                      <th width="300">Days Past Due (DPD)</th>
                      <th width="100">Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pf_clm_delinquent?.map((policy, index) => (
                      <tr key={index}>
                        <td width="400">
                          {deliquentPolicies.find(
                            (option) =>
                              option.value ===
                                policy?.pf_clm_deliquency_action ?? "-",
                          )?.label ?? "-"}
                        </td>
                        <td width="300">
                          {policy?.pf_clm_days_past_dueL ?? "-"}
                        </td>
                        <td width="100">
                          {policy?.pf_clm_days_month_opt ?? "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : null}
        </div>

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-4">KYC Process</div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Will KYC procedures be conducted to retain cardholder information such as Address, DOB, and ID to meet the applicable legal and regulatory compliance requirements?"
                value={toTitleCase(pf_kyc_process || pf_enable_kyc_conduct)}
              />
            </div>
            <div i2c-grid="6@md">
              {(pf_enable_kyc_conduct === "no" || pf_kyc_process === "no") &&
                pf_enable_kyc_conduct_no_reason && (
                  <ReviewAttribute
                    label="Reason for not performing KYC"
                    value={pf_enable_kyc_conduct_no_reason}
                  />
                )}
            </div>
          </div>
          {pf_kyc_process === "yes" || pf_enable_kyc_conduct === "yes" ? (
            <div>
              <div i2c-grid="6@md">
                <div className="review-summary-section-heading mt-8 mb-8">
                  Who will conduct KYC?
                </div>
              </div>
              {pf_kyc_conduct !== "other" ? (
                <ReviewAttribute
                  label="Who will conduct KYC?"
                  value={toTitleCase(pf_kyc_conduct)}
                />
              ) : (
                <div i2c-grid="6@md">
                  <div i2c-grid="grid gap-sm">
                    <ReviewAttribute
                      label={
                        pf_kyc_conduct_other ? "Other Details" : "Company Name"
                      }
                      value={
                        pf_kyc_conduct_other ||
                        toTitleCase(pf_kyc_conduct_other_company)
                      }
                    />
                    {pf_kyc_conduct_other_company && (
                      <>
                        <ReviewAttribute
                          label="Contact Name"
                          value={toTitleCase(pf_kyc_conduct_other_contact_name)}
                        />
                        <ReviewAttribute
                          label="Title"
                          value={pf_kyc_conduct_other_title}
                        />
                        <ReviewAttribute
                          label="Phone"
                          value={pf_kyc_conduct_other_phone}
                        />
                        <ReviewAttribute
                          label="Email"
                          value={toTitleCase(pf_kyc_conduct_other_email)}
                        />
                        <ReviewAttribute
                          label="Physical Address"
                          value={toTitleCase(pf_kyc_conduct_other_address)}
                        />
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          ) : null}
        </div>

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">KYB Process</div>
          <ReviewAttribute
            label="Will KYB (Know Your Business) procedures be conducted to examine entities that you wish to onboard."
            value={pf_kyb_process?.length ? toTitleCase(pf_kyb_process) : "-"}
          />
          {pf_kyb_process === "yes" ? (
            <div>
              <div i2c-grid="6@md">
                {pf_kyb_responsibility !== "other" ? (
                  <ReviewAttribute
                    label="Who will conduct KYB Responsibilities?"
                    value={toTitleCase(
                      pf_kyb_responsibility?.length
                        ? pf_kyb_responsibility
                        : "-",
                    )}
                  />
                ) : (
                  <>
                    <div i2c-grid="grid gap-sm">
                      <ReviewAttribute
                        label="Company Name"
                        value={
                          pf_kyb_responsibility_other_company?.length
                            ? toTitleCase(pf_kyb_responsibility_other_company)
                            : "-"
                        }
                      />
                      <ReviewAttribute
                        label="Contact name"
                        value={
                          pf_kyb_responsibility_other_contact_name?.length
                            ? toTitleCase(
                                pf_kyb_responsibility_other_contact_name,
                              )
                            : "-"
                        }
                      />
                      <ReviewAttribute
                        label="Title"
                        value={
                          pf_kyb_responsibility_other_title?.length
                            ? pf_kyb_responsibility_other_title
                            : "-"
                        }
                      />
                      <ReviewAttribute
                        label="Cell Number"
                        value={
                          pf_kyb_responsibility_other_phone?.length
                            ? pf_kyb_responsibility_other_phone
                            : "-"
                        }
                      />
                      <ReviewAttribute
                        label="Email"
                        value={
                          pf_kyb_responsibility_other_email?.length
                            ? toTitleCase(pf_kyb_responsibility_other_email)
                            : "-"
                        }
                      />
                      <ReviewAttribute
                        label="Physical Address"
                        value={
                          pf_kyb_responsibility_other_address?.length
                            ? toTitleCase(pf_kyb_responsibility_other_address)
                            : "-"
                        }
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          ) : null}
        </div>

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Card Order Placement
          </div>
          <div i2c-grid="grid" className="review-summary-gap">
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="How will a customer request to order a card and which channels will be used to send the card ordering requests?"
                value={
                  pf_card_order_placement?.length
                    ? (Array.isArray(pf_card_order_placement)
                        ? pf_card_order_placement
                        : [pf_card_order_placement]
                      )
                        .map(
                          (val) =>
                            cardOrderPlacement?.find((s) => s.value === val)
                              ?.label,
                        )
                        .filter(Boolean)
                        .join(", ")
                    : "-"
                }
              />
            </div>
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Select the channels:"
                value={formatSelectedLabels(
                  pf_card_order_placement_channel,
                  channel,
                  `(${pf_card_order_placement_channel_other})`,
                )}
              />
            </div>
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Select the i2c Inc. channels/interfaces you want the cardholders to use to activate card accounts."
                value={formatSelectedLabels(
                  pf_card_activation_channel,
                  cardActivationChannel,
                  pf_card_activation_channel_other,
                )}
              />
            </div>
          </div>

          <div i2c-grid="12@md">
            <div className="review-summary-section-heading mt-8 mb-8">
              PIN Management
            </div>

            <div i2c-grid="grid gap-sm">
              <div i2c-grid="6@md">
                <ReviewAttribute
                  label="How will the first card PIN be generated for the card?"
                  value={
                    pinManagmentOptions.find(
                      (opt) => opt.value === pf_pin_management,
                    )?.label
                  }
                />
              </div>
              <div i2c-grid="6@md">
                {pf_pin_management === "default-pin" ? (
                  <ReviewAttribute
                    label="If you select the default PIN option, please confirm the default PIN value."
                    value={
                      pf_pin_manage_default_pin !== "other"
                        ? pinManagememt.find(
                            (opt) => opt.value === pf_pin_manage_default_pin,
                          )?.label
                        : pf_pin_manage_default_pin_other
                    }
                  />
                ) : null}
              </div>
              <div i2c-grid="6@md">
                <ReviewAttribute
                  label="If you want to send the PIN through PIN Mailer?"
                  value={
                    pf_pin_mailer?.length ? toTitleCase(pf_pin_mailer) : "-"
                  }
                />
              </div>
              <div i2c-grid="6@md">
                <ReviewAttribute
                  label="Would you like Offline PIN support enabled for your BIN (mainly applicable for EU and Canada)?"
                  value={
                    pf_offline_pin_support?.length
                      ? toTitleCase(pf_offline_pin_support)
                      : "-"
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Consumer Payment Options
          </div>
          <ReviewAttribute
            label="Specify the payment options that you wish to enable for your cardholders."
            value={formatSelectedLabels(
              pf_consumer_payment_opt,
              constumerPaymentOptions,
              pf_consumer_payment_opt_other,
            )}
          />
        </div>

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Lockbox Service{" "}
          </div>
          {pf_lockbox_services !== "other" ? (
            <ReviewAttribute
              label="Lockbox Service"
              value={
                lockboxServices.find((opt) => opt.value === pf_lockbox_services)
                  ?.label
              }
            />
          ) : (
            <>
              {" "}
              <div className="overview-help-text font-bold mt-0">
                Please specify who will manage this service.
              </div>
              <div i2c-grid="grid gap-sm">
                <ReviewAttribute
                  label="Company Name"
                  value={
                    pf_lockbox_services_other_company?.length
                      ? toTitleCase(pf_lockbox_services_other_company)
                      : "-"
                  }
                />
                <ReviewAttribute
                  label="Contact name"
                  value={
                    pf_lockbox_services_other_contact_name?.length
                      ? toTitleCase(pf_lockbox_services_other_contact_name)
                      : "-"
                  }
                />
                <ReviewAttribute
                  label="Title"
                  value={
                    pf_lockbox_services_other_title?.length
                      ? pf_lockbox_services_other_title
                      : "-"
                  }
                />
                <ReviewAttribute
                  label="Phone"
                  value={
                    pf_lockbox_services_other_phone?.length
                      ? pf_lockbox_services_other_phone
                      : "-"
                  }
                />
                <ReviewAttribute
                  label="Email"
                  value={
                    pf_lockbox_services_other_email?.length
                      ? toTitleCase(pf_lockbox_services_other_email)
                      : "-"
                  }
                />
              </div>
            </>
          )}
        </div>

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Minimum Payment Calculation{" "}
          </div>
          {(pf_min_pc_pcalc_method?.length ||
            pf_min_pc_pprcntg_value?.length ||
            pf_min_pc_scalc_method?.length ||
            pf_min_pc_sprcntg_value?.length) && (
            <>
              <div className="overview-help-text mb-8 no-text-wrap">
                Minimum payment will be calculated for this card program
              </div>
              <div className="overview-val-text">
                <table border={1} cellSpacing={0}>
                  <thead>
                    <tr>
                      <th width="400" className="table-heading">
                        Select Primary Calculation Method
                      </th>
                      <th width="300">Define Percentage Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(pf_min_pc_pcalc_method?.length ||
                      pf_min_pc_pprcntg_value?.length) && (
                      <tr key={1}>
                        <td width="400">{pf_min_pc_pcalc_method}</td>
                        <td width="400">
                          {pf_min_pc_pprcntg_value}
                          <span className="font-bold">%</span>
                        </td>
                      </tr>
                    )}
                    {pf_min_pc_scalc_method?.length ||
                    pf_min_pc_sprcntg_value?.length ? (
                      <tr key={2}>
                        <td width="400">{pf_min_pc_scalc_method}</td>
                        <td width="400">
                          {pf_min_pc_sprcntg_value}
                          <span className="font-bold">%</span>
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            </>
          )}
          <div i2c-grid="12@md" className="mt-16">
            <div i2c-grid="grid gap-sm">
              <div i2c-grid="6@md">
                <ReviewAttribute
                  label="Minimum Payment Threshold"
                  value={
                    pf_min_payment_threshold?.length
                      ? toTitleCase(pf_min_payment_threshold)
                      : "-"
                  }
                />
              </div>
              <div i2c-grid="6@md">
                <ReviewAttribute
                  label="Select additional amounts to be included in the minimum payment."
                  value={formatSelectedLabels(
                    pf_min_payment_additional_amount,
                    additionalPayment,
                  )}
                />
              </div>
            </div>
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Payment Distribution Options
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Distribution options for payments greater than the minimum."
                value={
                  paymentDistributionOpt.find(
                    (opt) => opt.value === pf_payment_dist_opt_greater_min,
                  )?.label
                }
              />
            </div>
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Distribution options for the minimum payment."
                value={
                  distributionMinimumPay.find(
                    (opt) => opt.value === pf_payment_dist_opt_for_min,
                  )?.label
                }
              />
            </div>
          </div>
        </div>

        <div i2c-grid="12@md">
          <div i2c-grid="grid" className="review-summary-gap">
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Please confirm your Due Date policy."
                value={
                  "no-of-days" === pf_payment_due_date_policy
                    ? "Number of Days."
                    : "Fixed Date."
                }
              />
            </div>
            <div i2c-grid="6@md">
              <ReviewAttribute
                label={
                  "no-of-days" === pf_payment_due_date_policy
                    ? "Specify the number of days."
                    : "Specify the due date"
                }
                value={
                  "no-of-days" === pf_payment_due_date_policy
                    ? pf_payment_due_date_policy_no_of_days
                    : formatReviewDate(pf_payment_due_date_policy_fixed_date)
                }
              />
            </div>
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Statement Cycle Duration"
                value={pf_payment_statement_cycle_duration}
              />
            </div>
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Late Payment Penalty
          </div>
          <div i2c-grid="grid" className="review-summary-gap">
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Do you wish to define a late payment fee?"
                value={
                  pf_late_payment_penalty?.length
                    ? toTitleCase(pf_late_payment_penalty)
                    : "-"
                }
              />
            </div>
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Late payment fee"
                value={`${pf_late_payment_fee}`}
              />
            </div>
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Do you wish to define a grace period for late payment?"
                value={
                  pf_grace_period?.length ? toTitleCase(pf_grace_period) : "-"
                }
              />
            </div>
            <div i2c-grid="6@md">
              {pf_grace_period === "yes" ? (
                <ReviewAttribute
                  label="Grace period days"
                  value={pf_grace_period_days}
                />
              ) : null}
            </div>
          </div>
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="review-summary-section-heading mb-8">
            Card Account Statements
          </div>
          <ReviewAttribute
            label="Card Account Statements"
            value={formatSelectedLabels(
              pf_card_account_statement,
              cardAccountStatement,
            )}
          />
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="review-summary-section-heading mb-8">
            Statement Generation Date
          </div>
          <ReviewAttribute
            label="Do you want to specify the statement generation day of the month?"
            value={formatYesNo(pf_statement_generation)}
          />
          {pf_statement_generation === "yes" && (
            <ReviewAttribute
              label="Statement will be generated on the:"
              value={statementGeneratedOn.find(
                (opt) => opt.value === pf_statment_generation_date,
              )?.label}
            />
          )}
        </div>

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Credit Card Statement Printing & Mailing Services{" "}
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Please indicate who will be responsible for the printing and mailing of credit card statements."
                value={cardPrintingAndMailingService.find(
                  (opt) => opt.value === pf_credit_card_statement_printing_mailing_services,
                )?.label}
              />
            </div>
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Letter/Mail Generation and Printing Services{" "}
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Letter/Mail Generation and Printing Services"
                value={letterMailGenerationService.find(
                  (opt) =>
                    opt.value === pf_letter_mail_generation_services,
                )?.label}
              />
            </div>
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Credit Card Collection Details{" "}
          </div>
          <div i2c-grid="grid" className="review-summary-gap">
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Do you want i2c Inc. to provide account details for collection services?"
                value={formatYesNo(pf_credit_card_collection_detail)}
              />
            </div>
            {pf_credit_card_collection_detail === "yes" && (
              <div i2c-grid="6@md">
                <ReviewAttribute
                  label="Please confirm who will i2c Inc. provide account details for closed accounts intended for collection services."
                  value={
                    pf_credit_card_collection_detail_provider === "other"
                      ? toTitleCase(pf_credit_card_collection_detail_provider)
                      : "Program owner, specified above"
                  }
                />
              </div>
            )}
            {pf_credit_card_collection_detail === "yes" &&
              pf_credit_card_collection_detail_provider === "other" && (
              <div i2c-grid="12@md">
                <div className="overview-val-text font-bold mb-8">
                  Please specify who will manage this service.
                </div>
                <div i2c-grid="grid" className="review-summary-gap">
                  <ReviewAttribute
                    i2c-grid="6@md"
                    label="Name"
                    value={
                      pf_credit_card_collection_detail_provider_other?.length
                        ? pf_credit_card_collection_detail_provider_other
                        : "-"
                    }
                  />
                  <ReviewAttribute
                    i2c-grid="6@md"
                    label="Title"
                    value={
                      pf_credit_card_collection_detail_provider_other_title?.length
                        ? pf_credit_card_collection_detail_provider_other_title
                        : "-"
                    }
                  />
                  <ReviewAttribute
                    i2c-grid="6@md"
                    label="Phone"
                    value={
                      pf_credit_card_collection_detail_provider_other_phone?.length
                        ? pf_credit_card_collection_detail_provider_other_phone
                        : "-"
                    }
                  />
                  <ReviewAttribute
                    i2c-grid="6@md"
                    label="Email"
                    value={
                      pf_credit_card_collection_detail_provider_other_email?.length
                        ? pf_credit_card_collection_detail_provider_other_email
                        : "-"
                    }
                  />
                  <ReviewAttribute
                    i2c-grid="6@md"
                    label="Address"
                    value={
                      pf_credit_card_collection_detail_provider_other_address?.length
                        ? pf_credit_card_collection_detail_provider_other_address
                        : "-"
                    }
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Credit Bureau Reporting
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Please confirm if you want to subscribe to i2c Inc. credit bureau reporting services."
                value={formatYesNo(pf_credit_bureau_report_required)}
              />
            </div>
            <div i2c-grid="6@md">
              {pf_credit_bureau_report_required === "yes" ? (
                <ReviewAttribute
                  label="Please specify the credit bureaus below:"
                  value={formatSelectedLabels(
                    pf_credit_reporting_bureaus,
                    creditBreue,
                    pf_credit_reporting_bureaus_other,
                  )}
                />
              ) : null}
            </div>
          </div>
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="review-summary-section-heading mb-8">
            Card Usage Restrictions
          </div>
          <ReviewAttribute
            label="Do you want to limit where a card can be used?"
            value={formatYesNo(pf_card_usage_restriction)}
          />
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="review-summary-section-heading mb-8">
            Cash Advance Limits
          </div>
          <ReviewAttribute
            label="Do you wish to apply a cash advance limit?"
            value={formatYesNo(pf_cash_advance_limit)}
          />
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="review-summary-section-heading mb-8">
            Cardholder Notifications
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Will the card account activity related notifications be sent to
            cardholders or program managers?"
                value={
                  cardholderNotification.find(
                    (opt) => pf_cardholder_notification === opt.value,
                  )?.label ?? "-"
                }
              />
            </div>
            <div i2c-grid="6@md">
              {pf_credit_bureau_report_required === "yes" ? (
                <ReviewAttribute
                  label="Please select the channel through which alerts will be shared:"
                  value={formatSelectedLabels(
                    pf_cardholder_notifications_channels ||
                      pf_cardholder_notification_channels,
                    cardholderNotificationChannels,
                  )}
                />
              ) : null}
            </div>
          </div>
        </div>

        <div i2c-grid="12@md gap-sm">
          <div className="review-summary-section-heading mb-8">
            Customer Support
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Which customer support channels will be available for cardholders:"
                value={
                  customerSupportChannels.find(
                    (opt) => opt.value === pf_customer_support_channels,
                  )?.label
                }
              />
            </div>
            <div i2c-grid="6@md">
              <ReviewAttribute
                label="Who will provide customer support?"
                value={
                  customerSupportProvider.find(
                    (opt) => opt.value === pf_customer_support_who_will_provide,
                  )?.label
                }
              />
            </div>
          </div>
          {pf_customer_support_who_will_provide === "client-third-party" && (
            <>
              <div
                i2c-grid="12@md"
                className="overview-help-text font-bold mb-0"
              >
                3rd Party Vendor details:
              </div>
              <div i2c-grid="grid gap-sm">
                <ReviewAttribute
                  label="Company Name"
                  value={toTitleCase(
                    pf_customer_support_provider_other_company,
                  )}
                />
                <ReviewAttribute
                  label="Contact Name"
                  value={toTitleCase(
                    pf_customer_support_provider_other_contact_name,
                  )}
                />
                <ReviewAttribute
                  label="Title"
                  value={pf_customer_support_provider_other_title}
                />
                <ReviewAttribute
                  label="Phone"
                  value={pf_customer_support_provider_other_phone}
                />
                <ReviewAttribute
                  label="Email"
                  value={toTitleCase(pf_customer_support_provider_other_email)}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default ProgramFeaturesCreditOverview;
